export const HIDE_TIMEOUT = 5000;
